import React, { useMemo } from 'react';
import { Constants, Text } from '@shared/ui-components';


import { TagsInput } from 'common/components/tag-input';
import { EstimateSubscriptionError } from '../../../interfaces/estimate-subscription-error';
import { Styled } from './styled';

interface Props {
  coupons: string[];
  addCoupons: (coupons: string[]) => void;
  error: EstimateSubscriptionError;
}

export const Coupons: React.FC<Props> = React.memo((
  { coupons, addCoupons, error },
) => {
  const invalidCoupons = useMemo(
    () => {
      const couponIndex = error && error.couponIndex;
      if (Number.isInteger(couponIndex)) {
        const coupon = coupons[error.couponIndex];
        return coupon ? [coupon] : [];
      }
      return [];
    },
    [coupons, error],
  );

  const adviceText = error ? error.message : 'press "Enter" to add the promo code';

  return (
    <Styled.Container>
      <TagsInput
        tags={coupons}
        onChange={addCoupons}
        invalidTags={invalidCoupons}
        placeHolder={'Insert the promo code'}
      />
      <Text
        customColor={error ? Constants.Colors.GENERAL_COLORS.red : undefined}
        fontSize={10}
      >
        {adviceText}
      </Text>
    </Styled.Container>
  );
});

